import React from "react";
import {VStack} from "@chakra-ui/react";
import { AuthenticatedLayout } from "layouts";
import SessionsDataTable from "./SessionsDataTable";
import SessionsHeader from "./SessionsHeader";

const Sessions: React.FC = () => {

  return (
    <AuthenticatedLayout>
        <VStack alignItems="flex-start" spacing={8}>
          <SessionsHeader />
          <SessionsDataTable />
        </VStack>
    </AuthenticatedLayout>
  );
};

export default Sessions;
